import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var Container = /*#__PURE__*/ styled("div", {
    target: "e1tnw5ws0"
})("display:flex;flex-wrap:wrap;justify-content:space-between;gap:0.625rem;margin-bottom:2rem;", Theme.mq("sm"), "{flex-wrap:no-wrap;}");
var Image = /*#__PURE__*/ styled("img", {
    target: "e1tnw5ws1"
})("width:100%;filter:brightness(70%);transition:all 0.3s;");
var ItemContainer = /*#__PURE__*/ styled("div", {
    target: "e1tnw5ws2"
})("overflow:hidden;position:relative;display:block;box-sizing:border-box;flex-basis:100%;", Theme.mq("sm"), "{flex-basis:calc(50% - 0.625rem);}&:hover img{transform:scale(1.1);filter:brightness(100%);}");
var LinkContainer = /*#__PURE__*/ styled("a", {
    target: "e1tnw5ws3"
})("align-items:center;justify-content:center;display:flex;");
var ImageContainer = /*#__PURE__*/ styled("div", {
    target: "e1tnw5ws4"
})("display:inline-block;overflow:hidden;img{object-fit:cover;width:100%;height:auto;}");
var ReferralHeader = /*#__PURE__*/ styled("h2", {
    target: "e1tnw5ws5"
})("background-color:transparent;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:1.375rem;font-weight:700;position:absolute;text-align:center;text-shadow:0 0 5px ", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";z-index:2;");
export { Container, ItemContainer, ReferralHeader, Image, LinkContainer, ImageContainer };
